module.exports = __webpack_public_path__ + "img/vmc_aniv5_24Aug2021.cca793e6.jpg";